export default "__VITE_ASSET__ys6zhx6E__"